import React, { useState, useEffect, useRef } from "react";
import "../../App.css";
import HeroSection from "../home/HeroSection";
import AboutGeospatial from "../home/AboutGeospatial";
import { HomePageFooter } from "../layout/Footer";
import MDVisionSection from "../home/MDVisionSection";

// Home Page component that bundles the home sections
function HomePage({ handleNavClick }) {
  return (
    <>
      <HeroSection />
      <AboutGeospatial />
      <MDVisionSection />

      <HomePageFooter handleNavClick={handleNavClick} />
    </>
  );
}

export default HomePage;